import React, { useState, useEffect } from "react";
import { Table } from "semantic-ui-react";
import { ActionButtons, Container, StyledLabel } from "./styles";
import { FaWhatsapp } from "react-icons/fa";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { producaov2 as api } from "../../../../services/apis";
import { IoMdOpen } from "react-icons/io";
import { Form, Dropdown } from "semantic-ui-react";

export const BankOfTalents = () => {
  const [talentsBank, setTalentsBank] = useState([]);
  const [filteredArea, setFilteredArea] = useState({ value: "", error: "" });

  // Currículos são arquivos privados no file server — não têm URL pública.
  // Buscamos o PDF pela rota autenticada e abrimos o blob em nova guia.
  const handleOpenCurriculo = async (vacancy) => {
    const newTab = window.open("", "_blank");
    try {
      const response = await api.get(
        `/talent-bank/curriculo/download?id=${vacancy.id}`,
        { responseType: "blob" }
      );
      const contentType =
        response.headers["content-type"] || "application/pdf";
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      if (newTab) {
        newTab.location = url;
      } else {
        window.open(url, "_blank");
      }
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } catch (err) {
      if (newTab) newTab.close();
      alert("Não foi possível abrir o currículo.");
    }
  };

  const voittoAreas = [
    {
      key: 1,
      text: "Comercial",
      value: "comercial",
    },
    {
      key: 2,
      text: "Marketing",
      value: "marketing",
    },
    {
      key: 3,
      text: "Produtos",
      value: "produtos",
    },
    {
      key: 4,
      text: "Customer Success",
      value: "customer-success",
    },
    {
      key: 5,
      text: "Tecnologia",
      value: "tecnologia",
    },
    {
      key: 6,
      text: "Recursos Humanos",
      value: "recursos-humanos",
    },
    {
      key: 7,
      text: "Financeiro",
      value: "financeiro",
    },
    {
      key: 8,
      text: "Gestão",
      value: "gestao",
    },
  ];

  useEffect(() => {
    api
      .get("/talent-bank")
      .then((response) => setTalentsBank(response.data.items));
  }, []);

  const filteredTalents = !filteredArea.length
    ? talentsBank
    : talentsBank.filter(
        (talent) => !filteredArea || talent.area === filteredArea
      );

  return (
    <div
      style={{
        padding: "0 0 0px 250px",
      }}
    >
      <AdminMenu />
      <Container>
        <h1>Banco de Talentos</h1>

        <StyledLabel>Filtrar por área:</StyledLabel>
        <Dropdown
          placeholder="Selecione uma área"
          fluid
          selection
          clearable
          options={voittoAreas}
          onChange={(e, { value }) => setFilteredArea(value)}
        />
        <Table>
          <Table.Header>
            <Table.HeaderCell>ID</Table.HeaderCell>
            <Table.HeaderCell>Nome</Table.HeaderCell>
            <Table.HeaderCell>Telefone</Table.HeaderCell>
            <Table.HeaderCell>Área</Table.HeaderCell>
            <Table.HeaderCell>Curriculo</Table.HeaderCell>
            <Table.HeaderCell>Ações</Table.HeaderCell>
          </Table.Header>

          <Table.Body>
            {talentsBank &&
              filteredTalents.map((vacancy) => (
                <Table.Row key={vacancy.id}>
                  <Table.Cell>{vacancy.id}</Table.Cell>
                  <Table.Cell>{vacancy.name}</Table.Cell>
                  <Table.Cell>{vacancy.phone_number}</Table.Cell>
                  <Table.Cell>{vacancy.area}</Table.Cell>
                  <Table.Cell>
                    {vacancy.curriculo_filepath &&
                    vacancy.curriculo_filepath.length ? (
                      <a
                        href="#"
                        title="Visualizar currículo em nova guia"
                        onClick={(e) => {
                          e.preventDefault();
                          handleOpenCurriculo(vacancy);
                        }}
                      >
                        {vacancy.curriculo_filename} <IoMdOpen />
                      </a>
                    ) : (
                      <span>Não possui currículo</span>
                    )}
                  </Table.Cell>
                  <Table.Cell title="Entrar em contato">
                    <ActionButtons>
                      <a
                        href={`https://api.whatsapp.com/send?phone=${vacancy.phone_number}&text=Olá,%20${vacancy.name}`}
                        target="_blank"
                      >
                        <FaWhatsapp size={22} color="var(--color-primary)" />
                      </a>
                    </ActionButtons>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </Container>
    </div>
  );
};
